module.exports = __webpack_public_path__ + "static/media/Skip_hand_After.40055570.svg";